import request from '@/utils/http';

// 打印校验
export const printCheck = (data) => {
    return request({
        url: `/api-tms/dispatch/printCheck`,
        method: 'get',
        params: data
    });
};

// 头部查询
export const getDispathOrderLists = (data) => {
    return request({
        url: `/api-tms/dispatch/search`,
        method: 'post',
        data
    });
};

// 发车单管理编辑
export const getDispathOrderEdit = (data) => {
    return request({
        url: `/api-tms/dispatch/${data.dispatchNo}`,
        method: 'get',
        data
    });
};

// 到车
export const getDispathOrderRegister = (data) => {
    return request({
        url: `/api-tms/dispatch/updatearrive`,
        method: 'put',
        data
    });
};

// 取消到车
export const getDispathOrderNoRegister = (data) => {
    return request({
        url: `/api-tms/dispatch/cancelarrive`,
        method: 'put',
        data
    });
};

// 取消发车单
export const getDispathOrderNoInitiationSlip = (data) => {
    return request({
        // url: `/api-tms/dispatch/canceldepart`,
        url: `/api-tms/intelligent/cancel`,
        method: 'put',
        data
    });
};

// 发车
export const getDispathOrderStart = (data) => {
    return request({
        url: `/api-tms/dispatch/updatedepart`,
        method: 'put',
        data
    });
};

// 获取仓库信息
export const getDispathOrderPrinting = (params) => {
    return request({
        url: `/api-tms/dispatch/warehouse/dispatchinfo`,
        method: 'get',
        params
    });
};

// 公司外线路
export const updateOutLineContract = (data) => {
    return request({
        url: `/api-tms/dispatch/updateOutLineContract`,
        method: 'put',
        data
    });
};

// 打印
export const getDispathOrderWarehouse = (params) => {
    return request({
        url: `/api-tms/dispatch/print`,
        method: 'get',
        params
    });
};

// 蓝月亮打印
export const dispatchBluemoonPrint = (params) => {
    return request({
        url: `/api-tms/dispatch/bluemoon/print`,
        method: 'get',
        params
    });
};

// 供应商保存
export const getDispathOrderPreservation = (data) => {
    return request({
        url: `/api-tms/dispatch/updateeditdispatchinfo`,
        method: 'put',
        data
    });
};

// 打印（次数）
export const updataPrintTimes = (data) => {
    return request({
        url: `/api-tms/dispatch/updatePrintTimes`,
        method: 'put',
        data
    });
};

// 运输单状态数据字典接口（用于本地存储）
export const taskStatuLists = (data) => {
    return request({
        url: `/api-mdm/mdmDataDictionaryDetails?dictCode=TRANSPORT_STATUS`,
        method: 'get',
        data
    });
};
// 设备绑定/修改/解绑
export const saveupdatecancledevice = (data) => {
    return request({
        url: `/api-tms/dispatch/saveupdatecancledevice`,
        method: 'put',
        data
    });
};
// 导出
export const dispatchExport = (data) => {
    return request({
        url: `/api-tms/export/dispatch`,
        method: 'post',
        data
    });
};
// 成本校验
export const judgeCost = (data) => {
    return request({
        url: `/api-tms/dispatch/judgeCost`,
        method: 'post',
        data
    });
};
// 成本审批
export const startCostIflowApproval = (data) => {
    return request({
        url: `/api-tms/dispatch/startCostIflowApproval`,
        method: 'post',
        data
    });
};
// 根据发车单查运输单
export const getTaskData = (data) => {
    return request({
        url: `/api-tms/transport/list/sort`,
        method: 'post',
        data
    });
};
// 园区预约装卸货信息
export const getTransportBook = (data) => {
    return request({
        url: `/api-tms/transport/book`,
        method: 'post',
        data
    });
};
// 园区预约仓库信息
export const getAppointWh = (data) => {
    return request({
        url: `/api-tms/transportBook/bookingDays`,
        method: 'post',
        data
    });
};
// 园区预约保存
export const transportBookSave = (data) => {
    return request({
        url: `/api-tms/transportBook/bookings`,
        method: 'post',
        data
    });
};
// 园区预约更新状态
export const syncStatus = (data) => {
    return request({
        url: `/api-tms/transportBook/sync`,
        method: 'put',
        data
    });
};
// 在途路由查询历史记录
export const getOnTheWayData = (data) => {
    return request({
        url: `/api-tms/transitTracking/queryTrackingByDispatchNoAndTaskNo`,
        method: 'post',
        data
    });
};
// 在途路由保存
export const saveOnTheWayData = (data) => {
    return request({
        url: `/api-tms/transitTracking/saveTransitTracking`,
        method: 'post',
        data
    });
};
// 判断是否修改了详细地址
export const addressDetailHasChange = (data) => {
    return request({
        url: `/api-tms/transport/addressDetailHasChange`,
        method: 'post',
        data
    });
};
// 更改重量
export const updateVolumnWeight = (data) => {
    return request({
        url: `/api-tms/dispatch/updateVolumnWeight`,
        method: 'post',
        data
    });
};
// 运输协议查询
export const queryTransportProtocol = (data) => {
    return request({
        url: `/api-tms/transportProtocol/search`,
        method: 'post',
        data
    });
};
// 上传纸质协议
export const uploadTransportProtocol = (data) => {
    return request({
        url: `/api-tms/hand/upload/transportProtocol`,
        method: 'post',
        data
    });
};
// 重推
export const rePushTransportProtocol = (data) => {
    return request({
        url: `/api-tms/repush/transportProtocol`,
        method: 'post',
        data
    });
};
// 推送
export const pushTransportProtocol = (data) => {
    return request({
        url: `/api-tms/push/transportProtocol`,
        method: 'post',
        data
    });
};
// 取消装货
export const cancelTransportationApi = (data) => {
    return request({
        url: `api-tms/cancel/YS/by/dispatchNo/${data}`,
        method: 'put'
    });
};
// 打印前先校验是否为京东单，是要刷新手机号后才能打印
export const printValid = (data) => {
    return request({
        url: `/api-tms/transport/print/pdf/valid`,
        method: 'post',
        data
    });
};
// 查询装车顺序
export const selectallPage = (data) => {
    return request({
        url: `/api-tms/transport/selectallPage`,
        method: 'post',
        data
    });
};
// 保存装车顺序
export const updateWlLoadSequence = (data) => {
    return request({
        url: `/api-tms/transportExtend/updateWlLoadSequence`,
        method: 'post',
        data
    });
};
// 根据发车单获取运输单
export const getTaskList = (data) => {
    return request({
        // url: `/api-tms/transportExtend/searchUnitInfo`,
        url: `/api-tms/transport/ext/query`,
        method: 'post',
        data
    });
};
// 目标成本
export const getTargetCost = (data) => {
    return request({
        url: `/api-tms/dispatch/judgeCostSearch`,
        method: 'post',
        data
    });
};
// 白名单接口
export const getWhiteListApi = (params) => {
    return request({
        url: `/api-opms/opms/whitelist/list`,
        method: 'get',
        params
    });
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};
// 目标成本
export const changeTransportationCostApi = (data) => {
    return request({
        url: `/api-tms/dispatch/edit`,
        method: 'post',
        data
    });
};

// 批量在途登记校验
export const expressImportCheck = (data) => {
    return request({
        url: `/api-tms/dispatch/saveOnWayPositionTrace/expressImportCheck`,
        method: 'post',
        data
    });
};

// 批量在途登记确认
export const expressImportConfirm = (data) => {
    return request({
        url: `api-antms/transport/dispatch/saveOnWayPositionTrace/expressImportConfirm`,
        method: 'post',
        data
    });
};
